export default {
    shippingLabels: [],
    shippingLabelsLoading: false,
    shippingLabelStatuses: [],
    shippingLabelTypes: [],
    shippingLabelTemplates: [],
    shippingLabelsFilters: setInitialShippingLabelsFilters(),
    setInitialShippingLabelsFilters: setInitialShippingLabelsFilters,
}

function setInitialShippingLabelsFilters() {
    return {
        status_id: null
    }
}